import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField } from "../FormField";
import { RegisterFormData } from "../schema";
import { CountrySelect } from "@/components/ui/CountrySelect";

interface AddressSectionProps {
  control: Control<RegisterFormData>;
}

export const AddressSection = ({ control }: AddressSectionProps) => {
  const { t } = useTranslation();

  return (<>
  <div className="grid grid-cols-1 gap-4">
  <FormField
        name="streetAndHouseNumber"
        control={control}
        label={
          <>
            {t("register.labels.streetAndHouseNumber")}
            <span className="text-red-500">*</span>
          </>
        }
        placeholder={t("register.placeholders.streetAndHouseNumber")}
      />
  </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      
      <FormField
        name="postalCode"
        control={control}
        label={
          <>
            {t("register.labels.postalCode")}
            <span className="text-red-500">*</span>
          </>
        }
        placeholder={t("register.placeholders.postalCode")}
      />
      <FormField
        name="city"
        control={control}
        label={
          <>
            {t("register.labels.city")}
            <span className="text-red-500">*</span>
          </>
        }
        placeholder={t("register.placeholders.city")}
      />
    </div>
    <div className="grid grid-cols-1 gap-4">
      <CountrySelect
        name="country"
        control={control}
        label={t("register.labels.country")}
        placeholder={t("register.placeholders.country")}
        required={true}
        defaultValue="DE"
      />
    </div>
    </>  );
};